module.exports = __webpack_public_path__ + "img/img-main-bg01M.7667c687.png";